import PropTypes from 'prop-types';
import ImageProp from '../../../commonComponents/propTypes/imageProp';

const propType = {
  description: PropTypes.string,
  image: PropTypes.shape(ImageProp.propType),
  coins: PropTypes.number,
  voucher: PropTypes.object,
  coupon: PropTypes.object,
  certificate: PropTypes.object,
};

export default { propType };
